var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.177 7.20056C13.3769 7.20056 10.3779 9.59962 9.177 14.3997C10.9764 12.0004 13.0771 11.1007 15.4764 11.7006C16.8464 12.042 17.8254 13.0354 18.9097 14.1362C20.6742 15.9269 22.7167 18 27.177 18C31.9768 18 34.9761 15.6007 36.177 10.7994C34.3773 13.2002 32.2769 14.0999 29.8773 13.5C28.5076 13.1583 27.5297 12.1652 26.4441 11.0644C24.6806 9.27366 22.6388 7.20056 18.177 7.20056ZM9.177 18C4.37719 18 1.37794 20.3993 0.177002 25.2006C1.97644 22.7998 4.07681 21.9001 6.47644 22.5C7.84641 22.8417 8.82544 23.8348 9.90966 24.9356C11.6742 26.7263 13.7167 28.7994 18.177 28.7994C22.9768 28.7994 25.9761 26.4004 27.177 21.6003C25.3773 23.9996 23.2769 24.8993 20.8773 24.2994C19.5076 23.958 18.5297 22.9646 17.4441 21.8638C15.6806 20.0731 13.6388 18 9.177 18Z",
    fill: "#38BDF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.e727318ef4d0cec80aae245388bb0819.svg";
export { ForwardRef as ReactComponent };